import React from 'react';
import { Zap, ShieldCheck, Headphones, Feather } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal, SectionHeading } from './ui-blocks';

const ICONS = [Zap, ShieldCheck, Headphones, Feather];

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about-section" className="bg-cream py-24 md:py-32 border-t border-ink/10">
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-16">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-32">
            <SectionHeading
              eyebrow={t.about.eyebrow}
              title={t.about.title}
              subtitle={t.about.description}
              testId="about-heading"
            />
            <Reveal delay={0.3} className="mt-10">
              <span className="block w-16 h-1 bg-gold" />
            </Reveal>
          </div>
        </div>

        <ul className="md:col-span-7 flex flex-col" data-testid="about-features">
          {t.about.features.map((feature, index) => {
            const Icon = ICONS[index];
            return (
              <Reveal as="li" key={feature.title} delay={index * 0.08}>
                <div
                  data-testid={`about-feature-${index}`}
                  className="group grid grid-cols-[auto_1fr_auto] gap-6 md:gap-10 items-start py-8 md:py-10 border-t border-ink/10 last:border-b hover:bg-white/60 transition-colors"
                >
                  <span className="font-heading text-2xl md:text-3xl text-bordeaux leading-none pt-1">
                    0{index + 1}
                  </span>
                  <div>
                    <h3 className="font-heading text-xl sm:text-2xl text-ink">{feature.title}</h3>
                    <p className="mt-3 text-base text-ink/60 leading-relaxed max-w-md">{feature.desc}</p>
                  </div>
                  <span className="w-12 h-12 flex items-center justify-center border border-ink/10 text-bordeaux group-hover:bg-bordeaux group-hover:text-cream group-hover:border-bordeaux transition-colors">
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </span>
                </div>
              </Reveal>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default About;
